<template>
    <div >
        <div class="container-fluid mt--6 filter-show">
            <div class="abs-btn-grp-arbs">
                <div >
                    <div class="form-group input-group">
                        <!-- <div>
                            <span class="input-group-text">Account</span>
                        </div>
                        <div style="margin-right:5px;">
                            <select style="height:45px;border-radius:0" class="form-control cursor-pointer" v-model="accountId">
                                <option value="">Select Account</option>
                                <option v-for="account in accountList" :key="account.accountMappingId" :value="account.accountMappingId">{{account.account}}</option>
                            </select>
                        </div> -->
                        <button :disabled="loading || arbsUploadStatus == 'INPROGRESS'" @click="suspendAll()" type="button" class="btn btn-secondary rounded arbs-btn"><i class="far fa-minus-square mr-2"></i> SUSPEND ALL OFFERS </button>

                        <button :disabled="arbsUploadStatus == 'INPROGRESS'"   @click="clearData()" type="button" class="btn btn-warning rounded arbs-btn">
                            <i class="fas fa-trash"></i>
                            Clear ARBS
                        </button>
                        <div>
                            <span class="input-group-text">Spread</span>
                        </div>
                        <input v-model="spread" class="form-control" type="number">
                        <button :disabled="!spread" @click="saveSpread()" type="button" class="btn btn-success rounded arbs-btn">
                            <i class="fas fa-save"></i>
                            Save
                        </button>
                    </div>                                
                </div>
            </div>
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="row">
              <div class="col-lg-12">
                <form class="row">
                    <div class="col-md-2 col-lg-2">
                      <label for="filter" class="col-form-label">Select Ecn</label>
                      <select style="height:40px" class="form-control cursor-pointer" v-model="selectedEcn">
                        <option value="ibp">Bond Point</option>
                        <option value="twd">TWD</option>
                        <option value="tmc">TMC</option>
                      </select>
                    </div>
                    <div class="col-md-4 col-lg-4 arbs-upload">
                      <label for="filter" class="col-form-label">Upload File</label>
                      <div class="input-group">
                        <div class="custom-file">
                            <input v-if="selectedEcn == 'ibp'"  ref="fileupload" type="file" accept=".xls" class="custom-file-input cursor-pointer" id="file-upload"
                            aria-describedby="inputGroupFileAddon01" @change="onFileChange">
                            <input v-if="selectedEcn != 'ibp'" ref="fileupload" type="file" accept=".csv" class="custom-file-input cursor-pointer" id="file-upload"
                            aria-describedby="inputGroupFileAddon01" @change="onFileChange">
                            <label style="color:#000" class="custom-file-label cursor-pointer" for="file-upload">{{fileName ? fileName : 'Choose file'}}</label>
                        </div>
                        </div>
                    </div>
                     <div class="col-md-5 col-lg-5 mt-2">
                        <button :disabled="!fileName || arbsUploadStatus == 'INPROGRESS'" @click="uploadArbsFile()" type="button" class="btn btn-primary rounded">
                            <span v-if="arbsUploadStatus == 'INPROGRESS'">
                              <i class="fa fa-spinner fa-spin"></i>  Processing...
                            </span> 
                            <span v-if="!arbsUploadStatus">
                              <i class="fas fa-cloud-upload-alt"></i>  Upload
                            </span> 
                            <!-- <i v-if="!loading" class="fas fa-cloud-upload-alt"></i>
                            <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            Upload -->
                        </button>
                        <button type="button" class="btn btn-secondary rounded"  @click="clearUploadForm()">Clear</button>
                    </div>
                    <!--<div class="col-md-2 mt-2 col-lg-2">
                      <button :disabled="!fileName" @click="uploadArbsFile()" type="button" class="btn btn-primary rounded">
                        <i v-if="!loading" class="fas fa-cloud-upload-alt"></i>
                        <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                        Upload
                    </button>
                    </div>
                    <div class="col-md-2 mt-2 col-lg-2">
                        <button type="button" class="btn btn-primary rounded">
                        <i class="fas fa-cloud-upload-alt"></i>
                            Upload All</button>
                    </div> -->
                    <div class="col-md-3 mt-2 tbl-sch col-lg-3 input-group" style="top: 27px">
                        <button @click="uploadAll()" :disabled="arbsUploadStatus == 'INPROGRESS'" type="button" class="btn btn-success rounded arbs-btn">
                            <i v-if="loadingUpload" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            <i v-if="!loadingUpload" class="fa fa-paper-plane"></i>
                            Upload All Arbs
                        </button>

                        <input v-on:keyup.enter="getArbsList" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
                        <span  v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                        <span  @click="getArbsList()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-3">
                    <label>Filter By Ecn</label>
                     <multiselect 
                        v-model="filterEcn" 
                        placeholder="Ecn" 
                        :options="ecnList" 
                        :multiple="false" 
                        :showLabels="false"
                        :limit="4"  >
                    </multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3 mt-4" >
                    <label>Show forwarded arbs?</label>
                    <toggle-button :sync="true" v-model="showForwardedArbsOnly" @change="getArbsList()"/>
                 </div> 
                 <div class="col-md-6 col-lg-3" v-if="showForwardedArbsOnly">
                    <label>Forwarded by</label>
                     <multiselect 
                        v-model="forwardedBy" 
                        placeholder="Select user" 
                        label="firstName" 
                        track-by="traderId"
                        :options="userList"  
                        :multiple="true" 
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3" v-if="isUserTest">
                    <label>Filter By Trader</label>
                     <multiselect 
                        v-model="filterTrader" 
                        placeholder="Select traders" 
                        label="firstName" 
                        track-by="traderId"
                        :options="traderList"  
                        :multiple="false" 
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3 text-center">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-3">Clear</button>
                    <button @click="getArbsList()" type="button" class="btn btn-primary rounded mt-3">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >CUSIP</th>
                               <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >QTY / MIN.QTY</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >PRICE</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >ECN</th>
                                   <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >ECN <br> Price(s)</th>   
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >NOT ON <br> ECNs</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >STATUS</th>   
                                <th 
                                    scope="col" 
                                    class="sort text-center border-right"
                                    data-toggle="tooltip" data-placement="left" title="Whether offer already exists through IMS/Arbs"
                                   >OFFER <br> EXIST</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >SEND <br> QTY</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >SEND MIN. <br> QTY</th>       
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >SUGGESTED <br> PRICE</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >SEND <br> TO ECN</th>  
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-if="showForwardedArbsOnly"
                                    >TRADER</th>                                     
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr  v-for="(offer,i) in arbsList" :key="i" v-bind:class="{'cancel-bid-row' : offer.status == 'DELETED'}">
                                <td class="text-center">
                                    <span class="cusips">{{offer.cusip}}</span><br>
                                    <span data-toggle="tooltip" data-placement="left"  v-bind:title='offer.cusipDescription'>{{offer.cusipDescription | truncate(20, '...')}}</span>
                                </td>
                                <td class="text-center">{{offer.qty}}/{{offer.minQty}}</td>
                                <!-- <td class="text-center">{{offer.minQty}}</td> -->
                                <td class="text-center">{{offer.price | currency}}</td>
                                <td class="text-center">{{offer.ecn.toString()}}</td>
                                <td class="text-center">
                                  <div style="display: grid; text-align: left;">
                                  <span v-if="offer.ibpPrice" class="text-danger">IBP : {{ offer.ibpPrice | currency }}</span>
                                  <span v-if="offer.tmcPrice" class="text-success">TMC : {{ offer.tmcPrice | currency }}</span>
                                  <span v-if="offer.twdPrice" class="text-primary">TWD : {{ offer.twdPrice | currency }}</span>
                                </div>
                                </td>
                                <td class="text-center">{{offer.notInEcns.toString()}}</td>
                                <td class="text-center">{{offer.status}}</td>
                                <td class="text-center border-right">{{offer.offerExists.toString()}}</td>
                                <td class="text-center" style="width:65px">
                                    <input v-if="offer.status == 'ACTIVE'" maxlength="8" @keypress="isQuantity($event)" class="form-control" v-model="offer.sendQty"/>
                                    <span v-else>{{offer.sendQty}}</span>
                                </td>
                                <td class="text-center" style="width:65px">
                                    <input v-if="offer.status == 'ACTIVE'" maxlength="8" @keypress="isQuantity($event)" class="form-control" v-model="offer.sendMinQty"/>
                                    <span v-else>{{offer.sendMinQty}}</span>
                                
                                </td>
                                <td class="text-center" style="width:65px">
                                    <input v-if="offer.status == 'ACTIVE'" type="number" class="form-control" v-model="offer.sendSuggestedPrice"/>
                                    <span v-else>{{offer.sendSuggestedPrice}}</span>
                               
                                </td>
                                <td class="text-center">
                                    <multiselect 
                                        v-if="offer.status == 'ACTIVE'"
                                        v-model="offer.toBeSendToEcns" 
                                        placeholder="Ecn" 
                                        :options="ecnList" 
                                        :multiple="true" 
                                        :showLabels="false"
                                        :limit="4"  >
                                    </multiselect>
                                    <span v-else>{{offer.toBeSendToEcns.toString()}}</span>
                                    
                                </td>
                                <td class="text-center" v-if="showForwardedArbsOnly">{{offer.userFirstName}} {{offer.userLastName}}</td>

                                <td class="text-center">
                                    <button v-if="offer.status == 'ACTIVE' && offer.offeringId"  @click="editOffer(offer)" type="button" class="btn btn-primary rounded">Offering</button>
                                    <!-- <button type="button" class="btn btn-primary rounded">Save</button> -->
                                    <a  v-if="offer.status == 'ACTIVE'" @click="saveArbs(offer)" title="Save" class="btn ibtn btn-outline-success"><i class="fas fa-save mb-2"></i></a>
                                    <a  v-if="offer.status == 'ACTIVE'" @click="createOffer(offer)" title="Create Offer" class="btn ibtn btn-outline-success"><i class="fas fa-plus mb-2"></i></a>
                                    <a v-if="offer.status == 'ACTIVE'" @click="deleteArbs(offer)" title="Delete" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt mb-2"></i></a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getArbsList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <add-offer
            v-if="editOfferModalOpen"
            v-bind:offerCusip="offerCusip"  
            v-bind:selectedOffer="selectedOffer"  
            v-bind:mode="'EDIT'"  
            v-bind:platform="'ARBS'"  
            @close="editOfferModalOpen = false">
      </add-offer>
      
    </div>      
</template>
<script>
import AWS from 'aws-sdk/global';
import config from "@/config";
import authService from "@/authService";
import addOffer from "../ims-offering/ImsAddOfferModal"

export default {
  name: "imsCusipComponent",
  components : {
    addOffer
    
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "DESC",
        fileName : null,
        arbsList : [],
        selectedEcn : "ibp",
        ecnList : [ 'TWD','IBP','TMC'],
        spread : null,
        loadingUpload : false,
        showFilters : false,
        filterEcn : [],
        editOfferModalOpen : false,
        arbsUploadStatus : localStorage.getItem("ARBSUPLOADSTATUS"),
        accountId : "",
        accountList : [],
        filterTrader : null,
        traderList : [],
        isUserTest : authService.getUser().id === 1,
        isApiRunning : false,
        forwardedBy : [],
        userList : [],
        showForwardedArbsOnly : false

     
    };
  },
  methods: {
    suspendAll(){
      var message = "Are you sure you want to suspend all offers?";
      this.$confirm(message,"Suspend","question",{confirmButtonText:"Suspend",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .post(config.baseUrlBidSide + "/offer/arbs-suspend-all",{
            "cognitoSub":authService.getUser().cognitoSub,
            "showForwardedOnly":this.showForwardedArbsOnly,
            "forwardedBy" : this.forwardedBy.map((e) => {return e.cognitoSub})
          },auth)
          .then(() => {
            this.loading = false;  
            localStorage.setItem("ARBSUPLOADSTATUS", "INPROGRESS");
            this.arbsUploadStatus = localStorage.getItem("ARBSUPLOADSTATUS")
            this.$alert("Suspend in progress.","","success");            
          })
          .catch(() => {
              this.loading = false;              
          });
      });  
    },
    clearData(){
        var message = "Are you sure you want to clear ARBS?";
        this.$confirm(message,"Clear ARBS","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            this.loadingUpload = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .post(config.baseUrlBidSide + "/arbs/purge-user-data",{
                "cognitoSub":authService.getUser().cognitoSub
            },auth)
            .then(() => {
                this.loadingUpload = false;  
                this.$alert("Arbs data is being cleared","","success");            
                this.getArbsList();
                localStorage.setItem("ARBSUPLOADSTATUS", "INPROGRESS");
                this.arbsUploadStatus = localStorage.getItem("ARBSUPLOADSTATUS")
            
            })
            .catch(() => {
                this.loadingUpload = false;              
            });
        })
    },
    saveArbs(offer){
        let cusipType = offer.offeringTypeId === 1 ? "Munis" : "Corporates";
        if(cusipType == 'Munis' &&  offer.sendQty % 5 != 0 ){
          this.$alert("Send Quantity is not multiples of 5","","error");
          return ;
        }
        if(cusipType == 'Munis' &&  offer.sendMinQty % 5 != 0 ){
          this.$alert("Send Minimum Quantity is not multiples of 5","","error");
          return ;
        }
        if(offer.toBeSendToEcns.length == 0 ){
          this.$alert("Send To Ecn is required","","error");
          return ;
        }
        if(!offer.sendSuggestedPrice){
          this.$alert("Suggested price is required","","error");
          return ;
        }
        if(!offer.sendQty){
          this.$alert("Send quantity is required","","error");
          return ;
        }
        if(!offer.sendMinQty){
          this.$alert("Send minimum quantity is required","","error");
          return ;
        }
        
        if(Number(offer.sendQty) < Number(offer.sendMinQty)){
          this.$alert("Minimum quantity has to be less than or equal to send quantity","","error");
          return ;
        }
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        let data = {
                "id":offer.id,
                "sendSuggestedPrice": offer.sendSuggestedPrice,
                "sendQty" : offer.sendQty,
                "sendMinQty" : offer.sendMinQty,
                "notInEcns" : offer.notInEcns,
                "toBeSendToEcns" : offer.toBeSendToEcns,
                "updateByCognitoSub" : authService.getUser().cognitoSub
                }
        this.$http
        .put(config.baseUrlBidSide + "/arbs/update",data,auth)
        .then(() => {
            this.loading = false;  
            this.$alert("Offer updated.","","success");
            this.getArbsList();
        })
        .catch(() => {
            this.loading = false;              
        });
    },
    uploadAll(){
      var message = "Are you sure you want to upload all arbs offers?";
      this.$confirm(message,"Upload","question",{confirmButtonText:"Upload",cancelButtonText : "No"}).then(() => {
          this.loadingUpload = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .put(config.baseUrlBidSide + "/offer/sendtoecn-arbs",{
            "arbsId":-1,
            "cognitoSub":authService.getUser().cognitoSub,
            "showForwardedOnly":this.showForwardedArbsOnly,
            "forwardedBy" : this.forwardedBy.map((e) => {return e.cognitoSub})
          },auth)
          .then(() => {
            this.loadingUpload = false;  
            this.$alert("Offer upload in progress","","success");            
            this.getArbsList();
            localStorage.setItem("ARBSUPLOADSTATUS", "INPROGRESS");
            this.arbsUploadStatus = localStorage.getItem("ARBSUPLOADSTATUS")
           
          })
          .catch(() => {
              this.loadingUpload = false;              
          });
      });  
    },
    createOffer(offer){
      var message = "Are you sure you want to create a new offer?";
      this.$confirm(message,"Create Offer","question",{confirmButtonText:"Create",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .put(config.baseUrlBidSide + "/offer/sendtoecn-arbs",{
            "arbsId":offer.id,"cognitoSub":authService.getUser().cognitoSub,
            "showForwardedOnly":this.showForwardedArbsOnly,
            "forwardedBy" : this.forwardedBy.map((e) => {return e.cognitoSub})
          },auth)
          .then(() => {
            this.loading = false;  
            this.$alert("Offer creation in progress","","success");            
            this.getArbsList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });  
    },
    deleteArbs(offer){
      var message = "Are you sure you want to delete?";
      this.$confirm(message,"Delete","question",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .put(config.baseUrlBidSide + "/arbs/delete?arbsProcessedId="+offer.id+"&updateByCognitoSub="+authService.getUser().cognitoSub,{},auth)
          .then(() => {
            this.loading = false;              
            this.getArbsList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    },
    clearUploadForm(){
      this.fileName = null;
      document.getElementById("file-upload").value = null
    },
    uploadArbsFile(){
        if(this.loading){
            return
        }
        this.upload('input');
        
    },
    uploadFileToIBP(filePath){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let data  =  {
        //   "userId" : authService.getUser().id,
            "key": filePath,
            "cognitoSub" : authService.getUser().cognitoSub
        }
        this.$http
        .post(
            config.baseUrlBidSide +
            "/arbs/upload-ibp",
            data,
            auth
        )
        .then(() => {
            this.loading = false;
           // this.$alert("The file has been successfully uploaded. The file is being processed.","","success");
            this.clearUploadForm();
            this.getArbsList();
        })
        .catch(e => {
            console.log("Error", e);
            this.loading = false;
        });
    },
    uploadFileToTMC(filePath){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let data  =  {
        //   "userId" : authService.getUser().id,
            "key": filePath,
            "cognitoSub" : authService.getUser().cognitoSub
        }
        this.$http
        .post(
            config.baseUrlBidSide +
            "/arbs/upload-tmc",
            data,
            auth
        )
        .then(() => {
            this.loading = false;
            //this.$alert("The file has been successfully uploaded. The file is being processed.","","success");
            this.clearUploadForm();
            this.getArbsList();
        })
        .catch(e => {
            console.log("Error", e);
            this.loading = false;
        });
    },
    uploadFileToTWR(filePath){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let data  =  {
        //   "userId" : authService.getUser().id,
            "key": filePath,
            "cognitoSub" : authService.getUser().cognitoSub
        }
        this.$http
        .post(
            config.baseUrlBidSide +
            "/arbs/upload-twd",
            data,
            auth
        )
        .then(() => {
            this.loading = false;
            //this.$alert("The file has been successfully uploaded. The file is being processed.","","success");
            this.clearUploadForm();
            this.getArbsList();
        })
        .catch(e => {
            console.log("Error", e);
            this.loading = false;
        });
    },
    upload(albumName) {
        var s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: { Bucket: "imsfileupload"}
        });
        var files = document.getElementById("file-upload").files;
        if (!files.length) {
        return alert("Please choose a file to upload first.");
        }
        var file = files[0];
        var fileName = file.name;
        var albumPhotosKey = encodeURIComponent(albumName) + "/";
        var UUID = this.uuidv4();
        console.log(UUID);
        var photoKey = albumPhotosKey + fileName;
        var imsFolderName = "/arbs_"+this.selectedEcn+"/"
        var albumBucketName = config.albumBucketNameIms+imsFolderName+UUID;
        console.log(photoKey);
        this.loading = true;
        // Use S3 ManagedUpload class as it supports multipart uploads
        var self = this;
        localStorage.setItem("ARBSUPLOADSTATUS", "INPROGRESS");
        self.arbsUploadStatus = localStorage.getItem("ARBSUPLOADSTATUS")
        s3.upload(
        { Key: file.name, Bucket: albumBucketName, Body: file, ACL: "private" },
        function(err) {
            this.fileuploading = false;
            if (err) {
                console.log(err, "there was an error uploading your file");
                self.loading = false;
                self.arbsUploadStatus = null;
                localStorage.removeItem("ARBSUPLOADSTATUS");
                self.$alert("File upload session expired. Please try again.","","error").then(() => {
                    window.location.reload()
                })
            } else {
                if(self.selectedEcn == "ibp"){
                    self.uploadFileToIBP("arbs_ibp/"+UUID+"/"+file.name)
                }
                if(self.selectedEcn == "tmc"){
                    self.uploadFileToTMC("arbs_tmc/"+UUID+"/"+file.name)
                }
                if(self.selectedEcn == "twd"){
                    self.uploadFileToTWR("arbs_twd/"+UUID+"/"+file.name)
                }
                
                
            }
        }
        );
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.fileName = file.name;
    },
    search(){
        
    },
    clearFilter(){
        this.filterEcn = [];
        this.getArbsList();
    },
    clearSearch(){
        this.searchValue = "";
        this.getArbsList();
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        //this.getCustomers();
    },
    saveSpread(){
        let dataToSend = [
                            {
                                "setting": "ARBS_SPREAD",
                                "dataType": "NUMERIC",
                                "value": this.spread,
                                "cognitoSub": authService.getUser().cognitoSub
                            },
                            // {
                            //     "setting": "ARBS_ACCOUNT",
                            //     "dataType": "NUMERIC",
                            //     "value": this.accountId,
                            //     "cognitoSub": authService.getUser().cognitoSub
                                
                            // }
                        ]
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlBidSide +
                "/tradebook/setting",dataToSend,
                auth
            )
            .then(() => {
                this.loading = false;
                this.$alert("Saved successfully ","","success")
                this.getArbsList()
            })
            .catch(e => {
                console.log(e);
            });
    },
    getUserSetting(){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                this.userSettings = result.data;
                this.userSettings.forEach(element => {
                    if(element.setting == "ARBS_SPREAD"){
                        this.spread = element.value
                    }
                    if(element.setting == "ARBS_ACCOUNT"){
                        this.accountId = element.value
                    }
                });
                this.getArbsList();
            })
            .catch(e => {
                console.log(e);
            });
    },
    getAccountList(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/account/customer-account",
                auth
            )
            .then(result => {
                this.accountList = result.data;
                this.getUserSetting();
            })
            .catch(e => {
                console.log(e);
            });
    },
    getArbsList() {
      this.loading = true;
      this.isApiRunning = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/arbs/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub=" +
            (this.filterTrader ? this.filterTrader.cognitoSub : authService.getUser().cognitoSub)+
            "&showForwardedOnly="+
            this.showForwardedArbsOnly+
            "&forwardedBy="+
            (this.forwardedBy.length ? this.forwardedBy.map((e) => {return e.cognitoSub}).toString()  : "")+
            "&ecn="+(this.filterEcn ? this.filterEcn : ""),
            auth

        )
        .then(result => {
            this.totalRows = result.data.pageInfo.totalElements;
            result.data.content.forEach((data) =>{
                data.toBeSendToEcns = data.toBeSendToEcns.length > 0 ? data.toBeSendToEcns : data.notInEcns;
                data.sendQty = data.sendQty ? data.sendQty : data.qty;
                data.sendMinQty = (data.sendMinQty === null) ? data.minQty : data.sendMinQty;
                data.sendSuggestedPrice = data.sendSuggestedPrice ? data.sendSuggestedPrice.toFixed(3) : (data.price + Number(this.spread)).toFixed(3);
                // if(data.offerExists == 'arbs_ibp') data.offerExists = "ARBS IBP";
                // if(data.offerExists == 'arbs_tmc') data.offerExists = "ARBS TMC";
                // if(data.offerExists == 'arbs_twd') data.offerExists = "ARBS TWD";

            });
           this.arbsList = result.data.content;
           this.loading = false;
           this.isApiRunning = false;
        })
        .catch(e => {
          console.log("Error", e);
          this.isApiRunning = false;
          this.loading = false;

        });
    },
     editOffer(offer){
        this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/"+offer.offeringId,
                auth
            )
            .then(result => {
              this.loading = false;
              this.selectedOffer = result.data
                let cusip = {};
                cusip.cusip = offer.cusip;
                cusip.maturityDate = offer.maturityDate;
                cusip.callDate = offer.callDate;
                cusip.coupon = offer.coupon;
                cusip.stateId = offer.stateId;
                cusip.id = offer.cusipId;
                cusip.offeringTypeId = offer.offeringTypeId;
                this.offerCusip = cusip;
                this.editOfferModalOpen = true;
            })
    },
    getTraderList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
            auth
        )
        .then(result => {
          this.traderList = result.data.content;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getUserList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=&sortColumn=firstName&sortOrder=ASC&group&showForwarders=true&cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.userList = result.data.content;
        })
        .catch(e => {
          console.log(e);
        });
    },
   
  },
  mounted() {
    this.getAccountList();
    this.$root.$on("ARBS_FILE_PROCESSED", () => {
      if(!this.isApiRunning){
        this.getArbsList();
      }
    });
    this.$root.$on("ARBSUPLOADCOMPLETED", () => {
      this.arbsUploadStatus = null;
    });
    this.$root.$on("ARBS_OFFER_UPDATED", () => {
      this.arbsUploadStatus = null;
    });
    if(this.isUserTest){
        this.getTraderList();
    }
    this.getUserList();
  },
  beforeDestroy() {
    this.$root.$off("ARBS_FILE_PROCESSED");
    this.$root.$off("ARBSUPLOADCOMPLETED");
    this.$root.$off("ARBS_OFFER_UPDATED");
  },
  created(){
    let self = this;
    this.$cognitoAuth.getIdToken((err, result) => {
        if (err) {
            console.log("accessToken is not found", err);
        } else {
            this.accessToken = result;
        }
    });
    const userPoolLoginKey = config.userPoolLoginKey;
    const logins = {};
    logins[userPoolLoginKey] = this.accessToken;
    AWS.config.region = config.region;
    const cognitoParams = {
        IdentityPoolId: config.IdentityPoolIdFileUpload,
        Logins: logins
    };
    let cognitoidentity = new AWS.CognitoIdentity();
    cognitoidentity.getId(cognitoParams, function(err, data) {
        if (err) {
            console.log(err);
            self.showSessionReloadPoup()
        } else {
            console.log(data.IdentityId);
            let bucketRegion = AWS.config.region;
            AWS.config.update({
            region: bucketRegion,
            credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
            });
        }
    });
  }
};
</script>
<style scoped>
.abs-btn-grp-arbs{
    position: absolute;
    top: 55px;
    right: 110px;
}
</style>